import React from "react";
import { Box, Group, Drawer, Button, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import PickerDate from "../../components/general/PickerDate";

const GaransiFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateFilter,
    fnFilter
}) => {

    const [data, setData] = React.useState({
        tanggalPengajuanAwal: stateFilter.tanggalPengajuanAwal,
        tanggalPengajuanAkhir: stateFilter.tanggalPengajuanAkhir,
    });

    const handleFilter = () => {
        fnFilter(
            data.tanggalPengajuanAwal,
            data.tanggalPengajuanAkhir,
        )
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            tanggalPengajuanAwal: stateDefaultFilter.tanggalPengajuanAwal,
            tanggalPengajuanAkhir: stateDefaultFilter.tanggalPengajuanAkhir,
        }))
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Pengajuan Garansi</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Tanggal Pengajuan'
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <Group spacing='xs' noWrap>
                                <PickerDate
                                    stateMinDate={null}
                                    stateDate={data.tanggalPengajuanAwal}

                                    fnSetDate={(val) => setData(d => ({
                                        ...d,
                                        tanggalPengajuanAwal: val
                                    }))}

                                    stateSX={{
                                        flex: 1,
                                    }}

                                    stateFormat="DD MMM YYYY"
                                    stateClearable={true}
                                    stateLabel=''
                                    statePlaceHolder={data.tanggalPengajuanAwal === null ? 'Semua' : 'Tanggal Pengajuan'}
                                    stateWithAsterisk={false}
                                    stateDescription=''
                                    stateError=''
                                />

                                <Text size='sm'>s/d</Text>

                                <PickerDate
                                    stateMinDate={data.tanggalPengajuanAwal}
                                    stateDate={data.tanggalPengajuanAkhir}

                                    fnSetDate={(val) => setData(d => ({
                                        ...d,
                                        tanggalPengajuanAkhir: val
                                    }))}

                                    stateSX={{
                                        flex: 1,
                                    }}

                                    stateFormat="DD MMM YYYY"
                                    stateClearable={true}
                                    stateLabel=''
                                    statePlaceHolder={data.tanggalPengajuanAkhir === null ? 'Semua' : 'Tanggal Pengajuan'}
                                    stateWithAsterisk={false}
                                    stateDescription=''
                                    stateError=''
                                />
                            </Group>
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={handleReset}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            color='teal'
                            onClick={handleFilter}
                        >
                            Filter
                        </Button>
                    </Group>
                </Box>
            </Drawer>
        </React.Fragment>
    )
}

export default GaransiFilter;